import { Component, Input } from '@angular/core';
import { UtilsService } from 'app/core';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.component.scss']
})
export class FooterComponent {
  @Input() type: any = null;
  constructor(public uiService: UiService, public utilsService: UtilsService) {}
}
